import React, { useState } from "react";
import "./App.css";

import Navbar from "./components/Navbar.js";
import HeroBanner from "./components/HeroBanner.js";
import Footer from "./components/Footer.js";
import FooterNav from "./components/FooterNav.js";
import WhatsAppFloat from "./components/WhatsAppFloat.js";
import ScrollToTop from "./components/ScrollToTop.js";
import CalendlyModal from "./components/CalendlyModal.js";
import ProjectModal from "./components/ProjectModal.js";

import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { pageTransition } from "./utils/motionVariants";
import AboutPage from "./pages/AboutPage.js";
import ExperiencePage from "./pages/ExperiencePage.js";
import SkillsPage from "./pages/SkillsPage.js";
import ProjectsPage from "./pages/ProjectsPage.js";
import ProjectDetailsPage from "./pages/ProjectDetailsPage.js";
import ContactPage from "./pages/ContactPage.js";
import BlogPage from "./pages/BlogPage.js";
import BlogPostPage from "./pages/BlogPostPage.js";
import NotFoundPage from "./pages/NotFoundPage.js";
import HomePage from "./pages/HomePage.js";

export default function App() {
  const location = useLocation();
  const isHome = location.pathname === "/" || location.pathname === "/home";
  const [isCalendlyOpen, setCalendlyOpen] = useState(false);
  const [activeProject, setActiveProject] = useState(null);

  const openCalendly = () => setCalendlyOpen(true);
  const closeCalendly = () => setCalendlyOpen(false);
  const handleProjectSelect = (project) => setActiveProject(project);
  const closeProjectModal = () => setActiveProject(null);

  return (
    <>
      <ScrollToTop />
      <div className="app-shell">
        <Navbar onCalendlyClick={openCalendly} />
        {isHome && <HeroBanner onCalendlyClick={openCalendly} />}
        <main className="page-flow">
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial={pageTransition.initial}
              animate={pageTransition.animate}
              exit={pageTransition.exit}
            >
              <Routes location={location}>
                <Route path="/" element={<HomePage onCalendlyClick={openCalendly} onProjectSelect={handleProjectSelect} />} />
                <Route path="/home" element={<HomePage onCalendlyClick={openCalendly} onProjectSelect={handleProjectSelect} />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/experience" element={<ExperiencePage />} />
                <Route path="/skills" element={<SkillsPage />} />
                <Route path="/portfolio" element={<ProjectsPage onProjectSelect={handleProjectSelect} />} />
                <Route path="/project/:slug" element={<ProjectDetailsPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </motion.div>
          </AnimatePresence>
        </main>
        <Footer onCalendlyClick={openCalendly} />
        <FooterNav />
        <WhatsAppFloat />
        <CalendlyModal open={isCalendlyOpen} onClose={closeCalendly} />
        <ProjectModal project={activeProject} onClose={closeProjectModal} />
      </div>
    </>
  );
}
